'use es6';

import { Record, Map as ImmutableMap } from 'immutable';
import { FileTypes } from 'AdsUI/lib/Constants';
export default class FBSocialPostRecord extends Record({
  topVideoPost: null,
  id: null,
  headline: '',
  text: null,
  media: ImmutableMap(),
  cta: null,
  engagements: null,
  postDate: null,
  postType: null
}) {
  static fromNetwork(result) {
    return new FBSocialPostRecord({
      topVideoPost: result.postType === 'VIDEO',
      id: result.id,
      text: result.message,
      media: ImmutableMap({
        url: result.thumbnail,
        type: result.postType === 'IMAGE' ? FileTypes.IMG : result.postType === 'VIDEO' ? FileTypes.MOVIE : FileTypes.DOCUMENT
      }),
      cta: result.callToActionType,
      engagements: {
        likes: result.likes,
        comments: result.comments,
        shares: result.shares
      },
      postDate: result.date,
      postType: result.postType
    });
  }

}